(function ($) {
    $(function () {
        /** not enough sections? then this doesnt matter */
        if ($('section.fullscreen').length < 2) {
            return;
        }
        $('body').addClass('has-magnetic-sections');
        /** **************************
         * VARIABLES
         */
        var sections = $('section.fullscreen');
        var $pagination;
        var sectionsObserver;
        var currentSection = sections.first();
        var magneticTimeout;
        // only do this in desktop environments
        var mqMobile = window.matchMedia("(min-width: ".concat(window.BCB.magnetic_sections_breakpoint, "px)"));
        mqMobile.addEventListener('change', initOrDestroy);
        function initOrDestroy() {
            if (mqMobile.matches) {
                init();
            }
            else {
                destroy();
            }
        }
        // store resize and scroll functions for later use
        var resizeFunction = window.BCB.throttle(function () {
            checkSectionMagneticness();
            initSectionsObserver();
        }, 200);
        var scrollFunction = window.BCB.throttle(function () {
            clearTimeout(magneticTimeout);
            magneticTimeout = setTimeout(makeSectionMagnetic, 500);
        }, 100);
        // init and calculate stuff
        function init() {
            addSectionPagination();
            initSectionsObserver();
            checkSectionMagneticness();
            // recalculate on resize
            $(window).on('resize', resizeFunction);
            // go there once we stopped scrolling
            $(window).on('scroll', scrollFunction);
        }
        // destroy if on mobile
        function destroy() {
            if ($pagination) {
                $pagination.remove();
            }
            sectionsObserver = null;
            $(window).off('resize', resizeFunction);
            $(window).off('scroll', scrollFunction);
        }
        /** **************************
         * INITALS & CALCULATIONS
         */
        /**
         * add a section pagination
         */
        function addSectionPagination() {
            var pagination = '<ul class="section-pagination">';
            for (var s = 1; s <= sections.length; s++) {
                pagination += "<li class=\"section-".concat(s, "\"></li>");
            }
            pagination += '</ul>';
            $pagination = $(pagination);
            $('body').append($pagination);
        }
        /**
         * check if a section can be magnetic
         * once the content is too large to fit into one screen we want to let the user scroll on his own.
         */
        function checkSectionMagneticness() {
            sections.each(function (i, el) {
                if ($(el).outerHeight() <= $(window).height()) {
                    $(el).addClass('is-magnetic');
                }
                else {
                    $(el).removeClass('is-magnetic');
                }
            });
        }
        /**
         * init the sections observer with half the windows height as rootmargin
         */
        function initSectionsObserver() {
            // if we already have an observer, unobserve and destroy it.
            if (sectionsObserver) {
                sections.each(function (i, el) {
                    sectionsObserver.unobserve(el);
                });
            }
            // create a new observer - not the exact half of the window, as chrome doesn't like that.
            var value = -($(window).height() / 2 - 5);
            var options = { rootMargin: "".concat(value, "px 0px ").concat(value, "px  0px") };
            sectionsObserver = new IntersectionObserver(intersectionChanged, options);
            // and observe those sections
            sections.each(function (i, el) {
                sectionsObserver.observe(el);
            });
        }
        /** **************************
         * ACTIONS & UPDATES
         */
        /**
         * the state of a section changed.
         * @param entries
         */
        function intersectionChanged(entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    $(entry.target).addClass('current');
                    currentSection = $(entry.target);
                }
                else {
                    $(entry.target).removeClass('current');
                }
                updateSectionNavigation();
            });
        }
        /**
         * update the section navigation
         */
        function updateSectionNavigation() {
            $pagination.children('.current').removeClass('current');
            $pagination.children(":nth-child(".concat(currentSection.index() + 1, ")")).addClass('current');
            if (currentSection.hasClass('dark')) {
                $pagination.addClass('light');
            }
            else {
                $pagination.removeClass('light');
            }
        }
        /**
         * focus a section if it is magnetic
         */
        function makeSectionMagnetic() {
            if (currentSection && currentSection.hasClass('is-magnetic')) {
                var elTop = currentSection.offset().top;
                $('html, body').stop().animate({ scrollTop: elTop }, 500);
            }
        }
        /**
         * all good, all defined? Let's go!
         */
        initOrDestroy();
    });
})(jQuery);
